import { useRouter } from 'next/router';
import { useLang } from '@/i18n';
import EfCardsB from '@elem/ui/ef-cards-b';
import EfIcon from '@elem/ui/ef-icon';
import EfSection from '@elem/ui/ef-section';
import EfShopCardA from '@elem/ui/ef-shop-card-a';
import EfSpec from '@elem/ui/ef-spec';
import { Fragment } from 'react';
import EmailCom from '../../common/EmailCom';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('fourinone.teaser');
    const { locale = 'us' } = useRouter();
    const IS_NA_SITES = ['us', 'ca'].includes(locale);

    const itemsA = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724124419037/sectionA_card_1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724139017697/sectionA_card_1_h5.jpg',
            title: (
                <div className="SectionA-text1">
                    <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1724136383721/sectionA_icon.png" className="SectionA-text1-icon" />
                    {t('section_A_card1_title')}
                </div>
            ),
            itemMsgBgClass: 'ef-cards-b-item-msg-bg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724124767391/sectionA_card_2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724139037404/sectionA_card_2_h5.jpg',
            desc: t('section_A_card2_desc'),
            title: t('section_A_card2_title'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725354066793/sectionA_card_3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724139017092/sectionA_card_3_h5.jpg',

            desc: t('section_A_card3_desc'),
            title2: t('section_A_card3_desc2'),
            title: t('section_A_card3_title'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724124767565/sectionA_card_4.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724139017265/sectionA_card_4_h5.jpg',

            title: t('section_A_card4_title'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724124767774/sectionA_card_5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724139017885/sectionA_card_5_h5.jpg',

            title: t('section_A_card5_title'),
            desc: t('section_A_card5_desc'),
            title2: t('section_A_card5_desc2'),
        },
    ];
    const itemsB = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724124923069/sectionA_product_1.png',
            label: t('section_A_product1_label'),
            title: t('section_A_product1_title'),
            desc: t('section_A_product1_desc'),
            desc2: t('section_A_product1_desc2'),
            moreLink: `https://www.ecoflow.com/${locale}/delta-3-series-portable-power-station`,
            moreText: t('section_product_btn_text'),
        },
        // {
        //     pc: 'https://websiteoss.ecoflow.com/upload/image/1724124922934/sectionA_product_2.png',
        //     label: t('section_A_product2_label'),
        //     title: t('section_A_product2_title'),
        //     desc: t('section_A_product2_desc'),
        //     desc2: t('section_A_product2_desc2'),
        //     moreLink: `https://www.ecoflow.com/${locale}/delta-3-series-portable-power-station`,
        //     moreText: t('section_product_btn_text'),
        // },
    ];
    return (
        <div className={styles.TheComp} id="ID-SectionA">
            <EfSpec />
            <EfSection title={t('section_A_title')} desc={t('section_A_desc')} />
            <EfCardsB items={itemsA} />
            <EmailCom
                offTipsL={IS_NA_SITES ? 'Stay tuned for early release notifications and time-limited discounts' : t('section_early_bird_title')}
                productValue={[1]}
                gtm_event_name="delta3_submit"
                subscribeData={{
                    sector_name: t('section_A_title'),
                    entry_position: 4,
                }}
            />
            <div className="ef-container SectionA-list">
                {itemsB.map((item: any, index: number) => {
                    return (
                        <Fragment key={index}>
                            <EfShopCardA position="imgL" {...item} />
                        </Fragment>
                    );
                })}
            </div>
        </div>
    );
}
